module.exports = __webpack_public_path__ + "static/local-92238a93edb90972a81b763813d3cf2f.svg";